<template>
    <div class="pay-result">
        <!--
        <app-header            
            @on-click="goBack"
        ></app-header>
        -->
        <div class="mock-header" />

        <div v-if="!loadingDone" class="loading-box">
            <div class="loading-icon"></div>            
            <div class="loading-text f14">{{ $t('pay.result.loading_order_status') }}</div>
        </div>
        <div v-if="paymentStatus==='success'" class="success-box">
            <img src="../../assets/imgs/success-icon.png">
            <div class="text">{{ $t('pay.result.buy_success') }}</div>
        </div>
        <div v-if="paymentStatus==='fail'" class="fail-box">
            <div class="waiting_for_box">
                <div class="waiting-confirm-icon"></div>
                <div class="f20 bold">{{ $t('pay.result.buy_pending') }}</div>
                <div class="tip">{{ $t('pay.result.buy_pending_tip') }}</div>
            </div>
        </div>
        <div v-if="paymentStatus==='error'" class="fail-box">
            <div class="waiting_for_box">
                <div class="waiting-confirm-icon"></div>
                <div class="f20 bold">{{ $t('pay.result.buy_pending') }}</div>
                <div class="tip">{{ $t('pay.result.get_payment_info_fail') }}</div>
            </div>
        </div>
        <div class="payment-info-box">
            <div v-show="goodsName" class="list-item van-hairline--top-bottom">
                <div class="field">{{ urlData.sn ? $t('pay.result.goodsName') : $t('pay.result.cell_package') }}</div>
                <div class="value">{{ goodsName }}</div>
            </div>
            <div v-show="payPrice" class="list-item vux-1px-t van-hairline--bottom">
                <div class="field">{{ paymentStatus==='success' ? $t('pay.result.cell_buy_amount') : $t('pay.result.cell_real_amount') }}</div>
                <div class="value pay-price">
                    {{ payPrice }}
                </div>
            </div>
        </div>
        <div class="btns">
            <div class="btn go-to-order-btn" @click="goToOrder" v-if="Module_MyFlow && !urlData.sn">{{ $t('pay.result.go_to_order_btn') }}</div>
            <div class="btn back-to-home-btn mt15" @click="goToHome">{{ $t('pay.result.back_mall') }}</div>
        </div>

        <!-- 手机物理按键事件处理 -->
        <physical-key @back-event-handler="goToHome"></physical-key>
    </div>
</template>

<script>
    //import { isUndefOrEmpty, keepTwodecimalFull } from '../../utils/util';
    import { isUndefOrEmpty } from '../../utils/util';
    import checkProjectConfig from '@/lib/checkProjectConfig';

    export default {
        name: 'PayResult',        
        data() {
            return {
                goodsName: '',
                payPrice: '',
                loadingDone: false,
                interval_timer: null,
                interval_count: 0,
                paymentStatus: '',
                urlData: JSON.parse(sessionStorage.getItem('urlData') || '{}'),
            }
        },
        mounted() {
            this.queryOrderListForApp();
        },
        computed: {
            Module_MyFlow:function(){
                return checkProjectConfig.setAppThat(this).checkValue("Module_MyFlow",true);
            }
        },
        methods: {  
            goBack() {
            },
            goToOrder() {
                sessionStorage.setItem('orderType','flow');
                this.$router.replace(this.$setRouteQuery({
                    name: 'OrderList'
                },this));
            },
            goToHome() {
                if(this.urlData.sn){
                    this.$router.push({
                        name:"DigitalList",
                    })
                } else {
                    this.$router.push(this.$setRouteQuery({
                        path: '/'
                    },this))
                }
            },
            doPriceStyle(item, price) {
                //price = keepTwodecimalFull(price/100);
                //return `${item.currencyType} ${price}`;
                return this.globalPriceFormat(item.currencyType, price);                
            },
            updatePaymentStatus(status) {
                this.paymentStatus = status;
                this.loadingDone = true;
            },
            queryOrderListForApp() {
                if(this.$route.path !== '/pay/result') {
                    window.clearInterval(this.interval_timer);
                    return;
                }
                if(isUndefOrEmpty(this.$route.query.orderSn)) {    
                    //this.paymentStatus = 'error';
                    //this.loadingDone = true;
                    this.updatePaymentStatus('error');                
                    //this.$toast(this.$t('pay.result.ordersn_empty'));
                    return;
                }

                this.$http.post({
                    loading: false,
                    url: '/bss/app/order/queryOrderListForApp',
                    data: {                                               
                        orderSN: this.$route.query.orderSn
                    }
                }).then(res => {
                    if(res.data && res.data.dataList && res.data.dataList.length) {
                        let orderObj = res.data.dataList[0];
                        //this.payPrice = `${orderObj.currencyType} ${keepTwodecimalFull(orderObj.amount/100)}`;
                        this.payPrice = this.doPriceStyle(orderObj, orderObj.amount);

                        if(orderObj.offerList && orderObj.offerList.length) {
                            let packageObj = orderObj.offerList[0];
                            this.goodsName = packageObj.goodsName;
                        }

                        this.interval_count++;
                        // FINISHED 订单完成
                        if(orderObj.orderStatus === 'FINISHED') {
                            //this.loadingDone = true;
                            this.orderStatus = orderObj.orderStatus;
                            this.interval_timer && window.clearInterval(this.interval_timer);
                            //this.paymentStatus = 'success';
                            this.updatePaymentStatus('success');                            
                        } else {
                            // 最多执行3次
                            if(this.interval_count >= 3) {
                                window.clearInterval(this.interval_timer);
                                // 订单状态还是没有完成，待支付页面
                                //this.paymentStatus = 'fail';
                                //this.loadingDone = true;
                                this.updatePaymentStatus('fail');
                            } else {
                                window.clearInterval(this.interval_timer);
                                this.interval_timer = window.setInterval(() => {
                                    this.queryOrderListForApp();
                                }, 2000);
                            }
                        }
                    } else {
                        //this.paymentStatus = 'error';
                        //this.loadingDone = true;
                        this.updatePaymentStatus('error');                        
                        this.$toast(this.$t('pay.result.order_search_error'));
                    }
                });
            }
        },        
    }
</script>

<style scoped lang="less">
    @import "css/result.less";
</style>